"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
it('should render with the correct text', () => {
    expect(true).toBeTruthy();
});
//# sourceMappingURL=card.spec.js.map